module.exports = __webpack_public_path__ + "img/recent.6f304566.svg";